import { useUser } from '@client/new/hooks/use-user';
import * as enums from '@playbook-technologies/common-enums';
import { WithRouterProps } from 'react-router';
import { CreatorLayout } from '@client/new/components/creator-layout';
import { AdminLayout } from '@client/new/components/AdminMenu/AdminLayout';

const Dashboard: React.FC<React.PropsWithChildren<WithRouterProps>> = (p) => {
  const { user } = useUser();
  return user.role === enums.PortalUser.Role.Influencer.value ? (
    <CreatorLayout>{p.children}</CreatorLayout>
  ) : (
    <AdminLayout pathname={p.location.pathname}>{p.children}</AdminLayout>
  );
};

export default Dashboard;
